import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { WebsocketService } from "./../services/websocket.service";
import { ArrayAssociative } from '../core/array.core.data';

@Component({
	selector: 'neverume-stream',
	templateUrl: './stream.component.html',
	styleUrl: './stream.component.scss',
	standalone: !true
})
export class StreamComponent {
	@ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;

	constructor(private websocketService: WebsocketService) {

		// https://github.com/webrtc/samples/tree/gh-pages/src/content/getusermedia/canvas
		/*
				const video = window.video = document.createElement('video');
				video.setAttribute('autoplay',true);
				video.setAttribute('playsinline',true);
				document.body.appendChild(video);
		
				const canvas = window.canvas = document.createElement('canvas');
				document.body.appendChild(canvas);
				canvas.width = 480;
				canvas.height = 360;
		
				const constraints = {
				  audio: false,
				  video: true
				};
		
				function handleSuccess(stream) {
				  window.stream = stream; // make stream available to browser console
				  video.srcObject = stream;
				  requestAnimationFrame(() => {
					  canvas.width = video.videoWidth;
					  canvas.height = video.videoHeight;
					  canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
					}
				  );
				}
				function handleError(error) {
				  console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
				}
				navigator.mediaDevices.getUserMedia(constraints).then(handleSuccess).catch(handleError);
				
				*/
		try {
			//const devices = await navigator.mediaDevices.enumerateDevices();

			//	const audioOutputs = devices.filter(device => device.kind === 'audiooutput');

			//			audioOutputs.forEach(device => {
			//			const option = document.createElement('option');
			//option.value = device.deviceId;
			//option.text = device.label || `Device ${device.deviceId}`;
			//audioOutputSelect.appendChild(option);
			//		});
		} catch (err) {
			console.error('Error accessing audio devices:', err);
		}
	}

	videoDevices: MediaDeviceInfo[] = [];
	audioDevices: MediaDeviceInfo[] = [];
	selectedVideoDeviceId!: string;
	selectedAudioDeviceId!: string;

	ngOnInit(): void {
		this.getDevices().then();
	}

	async getDevices() {
		try {
			navigator.mediaDevices.getUserMedia({ video: 			{width: { ideal: 7680 }, 
			height: { ideal: 4320 }} , audio: true }).then(async () => {
				const devices = await navigator.mediaDevices.enumerateDevices();
				this.videoDevices = await devices.filter(device => device.kind === 'videoinput');
				this.audioDevices = await devices.filter(device => device.kind === 'audioinput');
				console.log(this.videoDevices);


			})
		} catch (err) {
			console.error('Error accessing devices:', err);
		};

	}


	onVideoSourceChange(event: MatSelectChange) {
		this.selectedVideoDeviceId = event.value;
	}

	onAudioSourceChange(event: MatSelectChange) {
		this.selectedAudioDeviceId = event.value;
	}

	async startStream() {
		if (!this.selectedVideoDeviceId || !this.selectedAudioDeviceId) {
			return;
		}

		const constraints = {
			video: { deviceId: { exact: this.selectedVideoDeviceId } },
			audio: { deviceId: { exact: this.selectedAudioDeviceId } }
		};

		try {
			const stream = await navigator.mediaDevices.getUserMedia(constraints);
			this.videoElement.nativeElement.srcObject = stream;
			// Захват видео с веб-камеры


			const videoTrack = stream.getVideoTracks()[0];
			const settings = videoTrack.getSettings();
			console.log("Current video track settings:", settings);
			console.log("Resolution:", settings.width, "x", settings.height);
			console.log("Frame rate:", settings.frameRate);

			// Используем MediaRecorder для записи и кодирования видеопотокаideo/mp4;codecs=\"vp9, vp9\" 
			let mediaRecorder = new MediaRecorder(stream, { mimeType: 'video/webm;codecs=av1' });

			console.log(mediaRecorder);
			let ws = this.websocketService;
			mediaRecorder.ondataavailable = async function(event: any) {
				if (event.data.size > 0) {
					let s: ArrayAssociative = {
						event: 'stream',
						type: event.data.type,
						w: settings.width,
						h: settings.height,
						vi: await event.data.arrayBuffer()

					}
					ws.sendws(s);
				}
			}.bind(ws);

			mediaRecorder.start(100); // Запись фреймов каждые 100 мс (10 кадров в секунду)

		} catch (err) {
			console.error('Ошибка доступа к медиа:', err);
		}
	}
}
